export default function Dashboard() {
  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>Добро пожаловать 👋</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: 15 }}>Выберите раздел в меню слева</p>
    </div>
  );
}
